import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import React from 'react';
import FactorActionComponent from 'components/FactorActionComponent/FactorActionComponent';
import { REVIEW_ENTRY_POINTS } from 'types/morph.pagePosition.constants';
import { useEventHandler } from 'hook/event.hook';

const ReviewEntryPointsModuleView = props => {
  const {
    history,
    offer,
    moduleHeading,
    moduleMetadata,
    selectedFactor,
    seenModuleTracking,
  } = props;
  const linkPath = '/globalReview';
  const eventHandler = useEventHandler();

  return (
    <FlexContainer className={'flex-column margT6'}>
      {seenModuleTracking}
      <FlexContainer className={'flex-column marglr48 m-marglr16'}>
        <FactorActionComponent
          text={`            
              <span className="fontLatoNormal900">
                Help members by leaving a card review
              </span>{' '}
              <br />
              <span className="system_info_i300_text">
                Share your credit card experience{' '}
              </span>
              <span className="fontLatoNormal400 ">
                to help others make informed decisions when choosing a card.
              </span>            
          `}
          icon={'creditCardIcon'}
          url={linkPath}
          history={history}
          offerModulePosition={1}
          selectedFactor={selectedFactor}
          offer={offer}
          eventHandler={eventHandler}
          moduleHeading={moduleHeading}
          moduleMetadata={moduleMetadata}
          seenOfferModuleName={REVIEW_ENTRY_POINTS}
          clickType={REVIEW_ENTRY_POINTS}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default ReviewEntryPointsModuleView;
